import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"


// Section title - title of the section part in Layout of the page
const SectionTitle = ({ title, left, mb, b_top, f_size }) => {
  return (
    <Container mb={mb} left={left}>
      <Title f_size={f_size} b_top={b_top}>{title}</Title>
    </Container>
  )
}


// --------------- Component Information --------------- //


SectionTitle.propTypes = {
  title: PropTypes.string,
  left: PropTypes.bool,
  mb: PropTypes.number,
  f_size: PropTypes.number,
  b_top: PropTypes.bool,
}


SectionTitle.defaultProps = {
  left: false,
  mb: 0,
  b_top: true,
  f_size: 6,
}


// --------------- Styled Components --------------- //


// Title container
const Container = styled.div`
  
  // Spacing
  margin: ${({ mb }) => `0 0 var(--spacer-${mb}) 0;`};
  padding: 0;
  
  // Flexbox
  display: flex;
  justify-content: ${props => props.left ? "flex-end;" : "flex-start;"};

`


// Title
const Title = styled.h2`

  // Spacing
  margin: 0;
  padding: var(--spacer-3) 0 0 0;

  // Font
  font-family: var(--headerFont);
  font-style: normal;
  font-weight: bold;
  font-size: var(--font-${props => props.f_size });
  line-height: 1.5;
  text-align: left;
  text-transform: uppercase;

  // Color
  color: var(--textRed);

  // Border
  border-top: ${props => props.b_top ? '3px solid var(--primaryRed)' : 'none' };
  border-radius: 0;

  // Display
  display: inline-block;

  // Positioning
  position: relative;
  bottom: 2px;
  
`


// ********** Exports ********** //


export default SectionTitle


// ********** EOF ********** //
